<template>
  <div class="bg-brand topbar">
    <img
      class="sys-logo"
      src="@/assets/img/soundsys_white.png"
      alt="BMAT"
    >
    <div class="burguer-menu show-small">
      <i class="fas fa-bars" @click="toggle" />
    </div>

    <div v-on-clickaway="clickOutsideSociety" class="nav-item dropdown pr60">
      <a
        :class="`nav-link  text-bar ${parents.length ? 'dropdown-toggle':''}`"
        data-toggle="dropdown"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        @click="show_society_drop = !show_society_drop"
      >
        {{ user.society|upper }}
      </a>

      <div
        v-if="parents.length"
        class="dropdown-menu"
        :class="{show:show_society_drop}"
      >
        <a
          v-for="availableSociety in parents"
          :key="availableSociety.id"
          class="dropdown-item"
          @click="setSociety(availableSociety)"
        >
          <i class="fas fa-retweet mr-2" />
          {{ availableSociety.username | upper }}
        </a>
      </div>
    </div>

    <i class="far fa-user-circle" />
    <img
      v-show="memberLogo && !isMlc"
      class="member-image pr-1"
      :src="memberLogo"
    >

    <div v-on-clickaway="clickOutside" class="nav-item dropdown pr60">
      <a
        class="nav-link dropdown-toggle text-bar"
        data-toggle="dropdown"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        @click="show_drop = !show_drop"
      >
        {{ user_name }}
      </a>

      <div
        class="dropdown-menu"
        :class="{show:show_drop}"
      >
        <a
          class="dropdown-item"
          @click="user_info"
        >
          <i class="far fa-user-astronaut mr-2" />
          {{ $t('myProfile') | capitalize }}
        </a>
        <a
          class="dropdown-item"
          @click="goToUsers"
        >
          <i class="far fa-user-friends mr-2" />
          {{ $t('people') | capitalize }}
        </a>
        <div class="dropdown-divider" />
        <a
          class="dropdown-item"
          @click="logout"
        >
          <i class="fa fa-sign-out mr-2" />
          {{ $t('logout') | capitalize }}
        </a>
      </div>
    </div>
  </div>
</template>

<style>
.bg-brand {
  background-image: url("../../assets/img/soundwave_bckg_green.png");
  background-position-y: center;
  background-repeat: repeat;
}

.fa-user-circle {
  color: white;
  font-size: 20px;
}

body.fade-out {
  opacity: 0;
  transition: 0.2s;
}
</style>

<style lang="scss" scoped>
@import "../../assets/styles/libs.scss";

.sys-logo {
  position: absolute;
  left: 10px;
  width: 48px;

  @media screen and (max-width: $break-large) {
    left: 50px;
  }
}

.burguer-menu {
  color: white;
  cursor: pointer;
  width: 48px;
  font-size: 24px;
  position: absolute;
  display: none;
  left: 10px;
}

.pr60 {
  padding-right: 60px;
}

.topbar {
  width: 100vw;
  position: fixed;
  height: 50px;
  top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 20;
}

.text-bar {
  color: white !important;
  font-size: 1.2em;
}
</style>


<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import { api } from "@/main"
import { mixin as clickaway } from "vue-clickaway"

export default {
  name: "TopBar",
  mixins: [clickaway],

  data () {
    return {
      show_drop: false,
      show_society_drop: false,
      show_society_log: false
    }
  },
  computed: {
    parents () {
      return this.$options.filters.get(this.user.profile, "societies", [])
    },
    ...mapGetters("soundsys", [
      "user_name",
      "memberLogo",
      "user_id",
      "img64",
      "isMlc",
    ]),
    ...mapGetters("members", ["logoSrc"]),
    ...mapState("soundsys", ["user"]),
    ...mapState("members", ["societies"])
  },
  methods: {
    ...mapActions("soundsys", ["getCountries", "getSrTypes", "getMembersList"]),
    ...mapMutations("ui", ["toggleNavbar"]),

    toggle (event) {
      event.stopPropagation()
      this.toggleNavbar()
    },
    logout () {
      localStorage.removeItem("claimList")

      document.body.className += " fade-out"
      setTimeout(this.$router.app.$auth.logout(), 500)
    },
    goToUsers () {
      this.show_drop = false
      this.$router.push({ name: "users-list" })
    },
    user_info () {
      this.show_drop = false
      this.$router.push({ name: "user-info" })
    },
    clickOutside () {
      this.show_drop = false
    },
    clickOutsideSociety () {
      this.show_society_drop = false
    },
    setSociety (selectedSociety) {
      this.show_society_drop = false

      api
        .post(`/users/${this.user.profile.user}/set_society/`, {
          society: selectedSociety.id
        })
        .then(() => {
          this.$router.go(0)
        })
        .catch(err => {
          this.$toasted.global.toast(err)
        })
    }
  },
  mounted () {
    this.getCountries()
    this.getSrTypes()
    this.getMembersList()

    let th = this

    ApiCalls.getSocieties()
      .then(x => {
        th.$store.commit("members/setSocieties", x)
      })
      .then(() =>
        ApiCalls.initial_setup().then(() => {
          const { name: routeName } = this.$router.currentRoute;

          // user have been reload user page
          // or was redirected directly here
          (routeName === "user-info") && this.user_info()

          this.$store.commit("soundsys/setDataReady", true)
          this.$store.commit("soundsys/setLogged", true)
        })
      )
  }
}
</script>
